// CARVERHAUS filters panel (blocks/filters.liquid, "Filter button opens a panel").
// On desktop Horizon opens #filters-drawer as a non-modal dialog, so a click on the
// dimmed page behind it (carver-haus.css, section 15b) does not reach the drawer's own
// backdrop handler. Close it here instead.
document.addEventListener('click', (event) => {
  const drawer = document.getElementById('filters-drawer');
  if (!drawer || !drawer.hasAttribute('open')) return;

  const target = event.target;
  if (!(target instanceof Element)) return;

  // Inside the panel, or the button that opened it
  if (drawer.contains(target) || target.closest('[aria-haspopup="dialog"]')) return;

  if (typeof drawer.close === 'function') drawer.close();
});
